import { Box, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

/** Matches nursing medicine request tracking subpage shell (NursingRequestTracking.jsx). */
export const PATHOLOGY_SUBPAGE_OUTER_SX = { width: "100%" };

export const PATHOLOGY_SUBPAGE_CONTENT_SX = {
  padding: 2,
  marginTop: 2,
  borderRadius: 2,
  marginRight: "90px",
};

export const PATHOLOGY_BACK_BUTTON_SX = {
  color: "#5D6A82",
  textTransform: "none",
  fontSize: "16px",
  fontWeight: "bold",
  padding: 0,
  transition: "none !important",
  marginBottom: "16px",
};

/** Page title row — same typography as Medicine Request Tracking. */
export const PATHOLOGY_PAGE_TITLE_SX = {
  fontFamily: "Open Sans",
  fontWeight: 600,
  fontSize: "20px",
  lineHeight: "29px",
  letterSpacing: "0px",
  color: "inherit",
};

export function PathologyBackButton({ onClick }) {
  return (
    <Button
      startIcon={<ArrowBackIcon />}
      onClick={onClick}
      sx={PATHOLOGY_BACK_BUTTON_SX}
    >
      Back
    </Button>
  );
}

export function PathologySubpageShell({ children }) {
  return (
    <Box sx={PATHOLOGY_SUBPAGE_OUTER_SX}>
      <Box sx={PATHOLOGY_SUBPAGE_CONTENT_SX}>{children}</Box>
    </Box>
  );
}
